<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import { BaseBtn, Icon, type BaseBtnProps, type IconName } from '@/ui/base';

  export interface Props {
    variant?: 'cta' | 'primary' | 'secondary' | 'generate' | 'analyze';
    icon?: IconName;
    iconLeft?: IconName;
    loading?: boolean;
  }

  export type CTAButtonProps = Props & BaseBtnProps;

  const styles = tv({
    base: 'fr gap-2 rounded-sm px-4 py-2',
    variants: {
      variant: {
        cta: 'fr-cc bg-btn-cta !text-label-sm  hocus:bg-btn-cta-H',
        primary: 'fr-cc bg-btn-prim  !text-label-sm  hocus:bg-btn-prim-H ',
        secondary: 'fr-cc bg-btn-sec !text-label-sm  hocus:bg-btn-sec-H',
        generate:
          'fr-cs w-full bg-gradient-to-b from-gentabs-from/50 to-gentabs-to/50 py-2.5  text-md hocus:from-gentabs-from/80 hocus:to-gentabs-to/80',
        analyze:
          'fr-cs w-full bg-gradient-to-b from-tabs-from/50 to-tabs-to/50 py-2.5  text-md hocus:from-tabs-from/80 hocus:to-tabs-to/80',
      },
      disabled: {
        true: 'bg-btn-disabled text-c-disabled hocus:bg-btn-disabled',
      },
    },
    compoundVariants: [
      {
        disabled: false,
        variant: ['cta', 'primary'],
        class: 'text-c-inverted',
      },
      {
        disabled: true,
        variant: 'primary',
        class: '!bg-btn-disabled',
      },
    ],
  });
</script>

<script lang="ts">
  let {
    variant = 'cta',
    disabled = false,
    class: className,
    children,
    loading = false,
    icon,
    iconLeft,
    ...props
  }: CTAButtonProps & { tooltip?: string } = $props();

  let iconName = $derived(loading ? 'Loading' : icon);

  let cn = $derived(styles({ variant, disabled: !!disabled, className }));
</script>

<BaseBtn {...props} disabled={!!disabled || loading} class={cn}>
  {#if loading}
    <Icon icon="Loading" size={4} />
  {:else}
    {#if iconLeft}
      <Icon icon={iconLeft} size={4} />
    {/if}
    {@render children?.()}
    {#if iconName}
      <Icon icon={iconName} size={4} />
    {/if}
  {/if}</BaseBtn
>
